exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".btn-lg[_v-017ad094]{width:80%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-017ad094&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/pages/Register-confirm.vue
// module id = 398
// module chunks = 0